import "../page";
import { createRoot } from "react-dom/client";
import "./index.css";
import { lazy, Suspense } from "react";
import NetworxProviders from "../../providers/NetworxProviders";
import { ThemeProvider as NextThemesProvider } from "next-themes";

import "./mock/mock-window";

import ToastTray from "../../components/ToastTray";
import { AB_TESTS } from "./utils/ab-tests-names";
import { getABTests } from "@/utils/ab-tests/ab-tests";
import * as Sentry from "@sentry/react";

// Lazy load versions
const SQFControl = lazy(() => import("./versions/control/ServiceQuoteFlow"));
const SQFChatFlow = lazy(() => import("./versions/chat-flow/ServiceQuoteFlow"));
const SQFPropertyAddress = lazy(() => import("./versions/property-address/ServiceQuoteFlow"));

const domNode = document.getElementById("app");
if (!domNode) {
  throw new Error("Could not find the app root element");
}
const root = createRoot(domNode);

const versionToShow = (() => {
  const abTests = getABTests();
  if (abTests.get(AB_TESTS.ST_CONVERSATIONAL_CHAT_FLOW).isCompare) {
    return AB_TESTS.ST_CONVERSATIONAL_CHAT_FLOW;
  }
  if (abTests.get(AB_TESTS.ST_PROPERTY_ADDRESS).isCompare) {
    return AB_TESTS.ST_PROPERTY_ADDRESS;
  }
  return "CONTROL";
})();

const themeForVersion = {
  [AB_TESTS.ST_CONVERSATIONAL_CHAT_FLOW]: "sqf-chat-flow",
  [AB_TESTS.ST_PROPERTY_ADDRESS]: "service-quote-flow-rewrite",
  "CONTROL": "service-quote-flow-rewrite",
} satisfies Record<typeof versionToShow & {}, string>;

Sentry.setTags({
  "page": "Service Quote Flow",
  "AB Test": versionToShow,
});

root.render(
  <NetworxProviders>
    <NextThemesProvider
      attribute="class"
      forcedTheme={versionToShow ? themeForVersion[versionToShow] : undefined }
    >
      <ToastTray />
      <Suspense fallback={<div className="h-screen w-screen flex items-center justify-center">Loading...</div>}>
        {versionToShow === "CONTROL" && <SQFControl />}
        {versionToShow === AB_TESTS.ST_CONVERSATIONAL_CHAT_FLOW && <SQFChatFlow />}
        {versionToShow === AB_TESTS.ST_PROPERTY_ADDRESS && <SQFPropertyAddress />}
      </Suspense>
    </NextThemesProvider>
  </NetworxProviders>
);
